import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";


const initialState = {
    dashboard: {overview:{}, byFamily:[], byType: [], byAz: [], accounts: []},
    filter: null,
    filterCat: '',
    scope: null,
    plan: null,
    reservationType: '',
    loading: false,
    error: null,
};

const fetchDashboardStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchDashboardSuccess = (state, action) => {
    return updateObject(state, {loading: false, dashboard: action.dashboard, error: null, filter: action.filter,
        filterCat: action.filterCat, scope: action.scope, plan: action.plan})
};

const fetchDashboardFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const changeReservationType = (state, action) => {
    return updateObject(state, {reservationType: action.reservationType})
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
      case actionTypes.DASHBOARD_FETCH_START: return fetchDashboardStart(state, action);
      case actionTypes.DASHBOARD_FETCH_SUCCESS: return fetchDashboardSuccess(state, action);
      case actionTypes.DASHBOARD_FETCH_FAIL: return fetchDashboardFail(state, action);
      case actionTypes.DASHBOARD_CHANGE_RESERVATION_TYPE: return changeReservationType(state, action);
      default: return state;
  }
};

export default reducer;
